import { FC } from 'react';
import AcceptAdjustment from './AcceptAdjustment';
import UseAcceptAdjustment from './UseAcceptAdjustment';

const AcceptAdjustmentContainer: FC = () => {
  return <AcceptAdjustment {...UseAcceptAdjustment()} />;
};

export default AcceptAdjustmentContainer;
